import React, { Component } from "react";
import { observer } from "mobx-react";
import DeliveryCallViewSelf from "./sub/DeliveryCallViewSelf";
import DeliveryCallViewExt from "./sub/DeliveryCallViewExt";
import { fn_closeDeliveryCall } from "../../../../function/FnBodyLayer";

@observer
class DeliveryCallView extends Component {
    render() {

        const { rootStore } = this.props;
        const layerStore = rootStore.layerStore;

        return (
            <div className={"layer_comm layer_common_type " + (layerStore.getLayerDeliveryCallView ? ' layer_open' : '')}>
                <div className="bg"></div>
                <div className="layer_content">
                    <div className="article_order_delivery">
                        <div className="section_tit_comm">
                            <h1>라이더 배달요청</h1>
                        </div>
                        <div className="section_content">
                            <div className="wrap_rider_tit">
                                <h2>라이더 선택</h2>
                                <div className="select">
                                    <button type="button" className={rootStore.deliveryStore.getDeliveryTab === "ext" ? "on" : ""}
                                        onClick={event => rootStore.deliveryStore.setDeliveryTab("ext")}
                                    >대행</button>
                                    <button type="button" className={rootStore.deliveryStore.getDeliveryTab === "self" ? "on" : ""}
                                        onClick={event => rootStore.deliveryStore.setDeliveryTab("self")}
                                    >자체</button>
                                </div>
                            </div>
                            {
                                (rootStore.deliveryStore.getDeliveryTab === "ext")
                                    ? <DeliveryCallViewExt rootStore={rootStore} />
                                    : <DeliveryCallViewSelf rootStore={rootStore} />
                            }
                        </div>
                        <div className="btn_close btn_close_comm">
                            <button
                                onClick={event => fn_closeDeliveryCall(rootStore)}
                            ><span>닫기</span></button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default DeliveryCallView;